"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BattleRunner = void 0;
const battleEventLog_1 = require("./battleEventLog");
const simulator_1 = require("./simulator");
const duration_1 = require("./utils/duration");
const isATeamDefeated = (board, pieceRegistry, combatStore) => {
    const survivingPieces = board
        .getAllPieces()
        .map((p) => pieceRegistry.getPieceById(p.id))
        .filter((p) => p !== null)
        .filter((p) => combatStore.getPiece(p.id).currentHealth > 0);
    const pieceOwnerIds = survivingPieces.map((p) => p.ownerId);
    return new Set(pieceOwnerIds).size <= 1;
};
class BattleRunner {
    constructor(board, pieceRegistry, combatStore, creatures, settings, startingTurn = 0, onEvents) {
        this.board = board;
        this.pieceRegistry = pieceRegistry;
        this.combatStore = combatStore;
        this.creatures = creatures;
        this.settings = settings;
        this.onEvents = onEvents;
        this.controls = { paused: false, stopped: false };
        this.turn = 0;
        this.eventLog = new battleEventLog_1.BattleEventLog();
        this.turn = startingTurn;
    }
    getTurn() {
        return this.turn;
    }
    pause() {
        this.controls.paused = true;
    }
    resume() {
        this.controls.paused = false;
    }
    stop() {
        this.controls.stopped = true;
    }
    run() {
        return __awaiter(this, void 0, void 0, function* () {
            while (true) {
                if (this.controls.stopped) {
                    return { turn: this.turn };
                }
                const shouldStop = this.turn >= this.settings.battleTurnCount ||
                    isATeamDefeated(this.board, this.pieceRegistry, this.combatStore);
                if (shouldStop) {
                    // Emit dying events and remove any pieces that died on the final turn
                    const deadPieceIds = [];
                    for (const p of this.board.getAllPieces()) {
                        const piece = this.pieceRegistry.getPieceById(p.id);
                        if (piece && this.combatStore.getPiece(p.id).currentHealth <= 0) {
                            this.eventLog.append({ type: "piece_dying", pieceId: p.id });
                            deadPieceIds.push(p.id);
                        }
                    }
                    const finalEvents = this.eventLog.consume();
                    if (finalEvents.length > 0 && this.onEvents) {
                        this.onEvents(finalEvents);
                    }
                    for (const id of deadPieceIds) {
                        this.board.removePiece(id);
                    }
                    if (this.settings.postBattleSettleMs > 0) {
                        yield (0, duration_1.duration)(this.settings.postBattleSettleMs).remaining().promise;
                    }
                    return { turn: this.turn };
                }
                while (this.controls.paused) {
                    if (this.controls.stopped) {
                        return { turn: this.turn };
                    }
                    yield (0, duration_1.duration)(1000).remaining().promise;
                }
                const turnTimer = this.settings.battleTurnDuration > 0
                    ? (0, duration_1.duration)(this.settings.battleTurnDuration)
                    : null;
                (0, simulator_1.simulateTurn)(++this.turn, this.board, this.pieceRegistry, {
                    combatStore: this.combatStore,
                    creatures: this.creatures,
                    eventLog: this.eventLog,
                });
                const events = this.eventLog.consume();
                if (events.length > 0 && this.onEvents) {
                    this.onEvents(events);
                }
                if (turnTimer !== null) {
                    yield turnTimer.remaining().promise;
                }
            }
        });
    }
}
exports.BattleRunner = BattleRunner;
